import Oidc from 'oidc-client'

// Load config directly instead of relying on window.appConfig
const config = require('../../config/runtime_config.js')

Oidc.Log.logger = console
// Oidc.Log.level = (config._$ppt9qr === 'production') ? Oidc.Log.ERROR : Oidc.Log.DEBUG
Oidc.Log.level = Oidc.Log.ERROR

let instance

// OIDC Client
export const getOidcClient = () => {
	if (instance) {
		return instance
	}

	const callbackUrl = window.location.origin + '/complete/tpauth-oidc/'

	instance = new Oidc.UserManager({
		userStore: new Oidc.WebStorageStateStore(),
		authority: config._$jpa1qd,
		client_id: config._$gfku26,
		redirect_uri: callbackUrl,
		silent_redirect_uri: callbackUrl, // Use same callback for silent renew
		response_type: 'code',
		scope: config._$t8je8g,
		post_logout_redirect_uri: window.location.origin + '/',
		automaticSilentRenew: true,
		filterProtocolClaims: false,
		loadUserInfo: true,
		includeIdTokenInSilentRenew: true,
		accessTokenExpiringNotificationTime: 60 // Notify 60 seconds before expiry
	})

	return instance
}



// WEBPACK FOOTER //
// ./src/services/oidc_client.js